// @flow

import React from 'react';
import { Collapse as ReactCollapse } from 'react-collapse';
import { UpArrow, DownArrow } from 'seedling/icons';

type Props = {
  // Every Collapse needs id so it can be targeted by an associated aria-controls
  id: string,
  isOpened: boolean,
};

class Collapse extends React.Component<Props> {
  render() {
    return <ReactCollapse {...this.props} />;
  }
}

type ExpandProps = {
  expanded: boolean,
  'aria-controls': string,
  className?: string,
};

const ExpandArrow = ({
  expanded,
  'aria-controls': ariaControls,
  className,
}: ExpandProps) => {
  let Arrow = expanded ? UpArrow : DownArrow;
  return (
    <Arrow
      className={className}
      aria-controls={ariaControls}
      aria-expanded={expanded}
    />
  );
};

export { Collapse, ExpandArrow };
